import { useLayoutEffect, useState, type RefObject } from 'react';

/**
 * Реальная отрендеренная ширина элемента (ResizeObserver, не статичное
 * число) — источник истины для зависимых layout-значений, которые CSS сам
 * посчитать не может (напр. left второй закреплённой колонки таблицы должен
 * точно равняться ширине первой, а не дублировать её как отдельное магическое
 * число, которое легко рассинхронизировать при правке одной из сторон).
 */
export function useElementWidth<T extends HTMLElement>(ref: RefObject<T | null>): number | null {
  const [width, setWidth] = useState<number | null>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = () => setWidth(el.getBoundingClientRect().width);
    update();

    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return width;
}
